import type { JSX } from 'react';
import { Logo } from './Logo';
import { NAV_ID } from './NavSidebar';
import { session } from '../data/session';
import { IDP_IS_A_STAND_IN } from '../config';
import { SETTINGS_PATH, type View } from '../routes';

interface Props {
  readonly navOpen: boolean;
  readonly onToggleNav: () => void;
  readonly onChangeView: (view: View) => void;
}

export function TopBar({ navOpen, onToggleNav, onChangeView }: Props): JSX.Element {
  const label = navOpen ? 'Hide menu' : 'Show menu';

  return (
    <header className="topbar">
      <span className="topbar__brand">
        {/* Far left, directly above the menu it slides in and out. One button
            in two states, so focus stays put when it flips; the label states
            the action rather than the state. */}
        <button
          type="button"
          className="hamburger"
          onClick={onToggleNav}
          aria-expanded={navOpen}
          aria-controls={NAV_ID}
          aria-label={label}
          title={label}
        >
          <svg width="18" height="18" viewBox="0 0 18 18" aria-hidden="true">
            <path d="M3 5h12M3 9h12M3 13h12" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
          </svg>
        </button>
        <Logo />
        The Fatigue App
        <span className="topbar__sub">Clinician view</span>
      </span>

      <div className="topbar__right">
        {/* Loud on purpose. The token is real and really verified, but the
            thing that issued it is a stand-in running on this laptop, and a
            build wearing that badge must not be mistaken for one signing
            people in against a real pool. */}
        {IDP_IS_A_STAND_IN && (
          <span className="devswitch__tag" title="Tokens come from the local IdP, not Cognito">
            DEV IdP
          </span>
        )}
        {/* The address rather than the display name: the name lives in the
            membership record, and the top bar has only the token, which
            carries what the person typed to get here. A link to their own
            settings, which is where anything about that person lives; handled
            in place on a plain click, like the menu's links. */}
        <a
          href={SETTINGS_PATH}
          className="topbar__who"
          title="Your settings"
          onClick={(event) => {
            if (event.metaKey || event.ctrlKey || event.shiftKey || event.button !== 0) return;
            event.preventDefault();
            onChangeView('settings');
          }}
        >
          {session()?.email}
        </a>
      </div>
    </header>
  );
}
